// extracted by mini-css-extract-plugin
module.exports = {"parentLink":"parent_parentLink__L77Pe"};